import "./auto_routing.scss";

let autoRoutingComponent = {
  restrict: "E",
  bindings: {},
};

export default autoRoutingComponent;



// WEBPACK FOOTER //
// ./client/app/components/auto_routing/auto_routing.component.js